import * as eventListActions from '../actions/publicEventList';

var defaultState = {
    events: [],
    modules: [],
    isShowingMobileFilters: false,
    searchText: '',
    sortBy: 'date',
    filterByModuleId: '0',
    filterByEventType: '0'
};

export default function(state = defaultState, action) {

    switch (action.type) {

        case eventListActions.EVENT_SUBJECT_FILTER_CHANGED:

            return {
                ...state,
                filterByModuleId: action.moduleId
            };

        case eventListActions.EVENT_TYPE_FILTER_CHANGED:

            return {
                ...state,
                filterByEventType: action.eventType
            };

        case eventListActions.EVENT_SORT_BY_CHANGED:

            return {
                ...state,
                sortBy: action.sortBy
            };

        case eventListActions.EVENT_SEARCH_TEXT_CHANGED:

            return {
                ...state,
                searchText: action.searchText
            };

        case eventListActions.MODULE_OPTIONS_REFRESHED:

            return {
                ...state,
                modules: action.modules
            };

        case eventListActions.PUBLIC_EVENTS_REFRESHED:

            return {
                ...state,
                events: action.events
            };

        case eventListActions.TOGGLE_MOBILE_FILTERS:

            return {
                ...state,
                isShowingMobileFilters: !state.isShowingMobileFilters
            };

        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./reducers/eventsList.js